import { Axios } from "./request";

const API_URL = "mainapi/v1/lookups/";

export const LOOKUPS_API = {
  GetEyeColors: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=1000`);
  },
  GetEthnicities: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=2000`);
  },
  GetReligions: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=3000`);
  },
  GetPoliticalOrientation: (isFiltered) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=5000&isFiltered=${isFiltered}`);
  },
  GetSkinColors: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=6000`);
  },
  GetMaritalStatus: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=7000`);
  },
  GetMaritalStatusForFamilyInfo: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=36000`);
  },
  GetResidenceAbroadType: (isFiltered) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix/?prefix=8000&isFiltered=${isFiltered}`);
  },
  GetFirstDateTypes: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=9000`);
  },
  GetParentsLivingStatus: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix/?prefix=10000`);
  },
  GetEconomicStatus: (isFiltered) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix/?prefix=11000&isFiltered=${isFiltered}`);
  },
  GetHousingStatuses: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix/?prefix=12000`);
  },
  GetClothingTypes: (isMan, isFiltered = true) => {
    return Axios.get(
      `${API_URL}GetLookupsByPrefix?prefix=${isMan ? 37000 : 13000}&isFiltered=${isFiltered}`
    );
  },
  GetGrades: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=14000`);
  },
  GetEducationalStatus: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=15000`);
  },
  GetSeminaryEducationalStatus: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=16000`);
  },
  GetUniversityTypes: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=17000`);
  },
  GetLevels: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=18000`);
  },
  GetEducationalGroup: (isFiltered) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=19000&isFiltered=${isFiltered}`);
  },
  GetEmployeeStatuses: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=20000`);
  },
  GetJobs: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=21000`);
  },
  GetContractTypes: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=22000`);
  },
  GetIncomeAmounts: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=23000`);
  },
  GetSpouseWorkingMatter: (isFiltered) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=25000&isFiltered=${isFiltered}`);
  },
  GetSpouseEthnicity: (isFiltered) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=26000&isFiltered=${isFiltered}`);
  },
  GetSpousePersonalityType: (isFiltered) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix/?prefix=27000&isFiltered=${isFiltered}`);
  },
  GetBeliefStatus: (isFiltered) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix/?prefix=28000&isFiltered=${isFiltered}`);
  },
  GetLifeStatuses: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix/?prefix=29000`);
  },
  GetIsClergyman: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=31000`);
  },
  GetFitnessTypes: (isFiltered) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=32000&isFiltered=${isFiltered}`);
  },
  GetEducationLevels: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix/?prefix=33000`);
  },
  GetHousingStatusesForFamilyInfo: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix/?prefix=34000`);
  },
  GetEducationalStatusForFamilyInfo: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=35000`);
  },
  GetReligionTypesByReligionId: (religionId) => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=${religionId}`);
  },
  GetEducationBranches: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=42000`);
  },
  GetEmploymentTypes: () => {
    return Axios.get(`${API_URL}GetLookupsByPrefix?prefix=45000`);
  },
};
